export default __webpack_public_path__ + "static/media/performanceD5.c5ed0a49.png";